import * as core from '@/application/search-core';
import CONST from '@/application/constants';
import _ from 'lodash';
import i18n from '@/plugins/i18n';

export function getValidSearchTypes ()
{
  let searchTypes = core.getValidSearchTypes();

  _.remove(searchTypes, (st) => {
    return st === CONST.SEARCH_TYPE_CITATION;
  });

  return searchTypes;
}

export function getSearchResultHeaders (searchType)
{
  let headers = core.getSearchResultHeaders(searchType);
  if (searchType === CONST.SEARCH_TYPE_CALENDAR) {
    _.remove(headers, ['value', 'departmentActorInstance.displayName']);// calendar.department
    _.remove(headers, ['value', 'judgeActorInstances']);// calendar.assignment
  }
  else if (searchType === CONST.SEARCH_TYPE_PARTY)
  {
    headers = [];

    headers.push({ text: i18n.t('page.searchResults.case.caseNumber'), value: 'caseHeader.caseNumber', sortable: true });
    headers.push({ text: i18n.t('page.searchResults.party.name'), value: 'partyHeader.partyActorInstance.sortName', sortable: true });
    headers.push({ text: i18n.t('page.searchResults.case.category'), value: 'caseHeader.caseCategory', sortable: true });
    headers.push({ text: i18n.t('page.searchResults.case.filedDate'), value: 'caseHeader.filedDate', sortable: true });
    headers.push({ text: i18n.t('page.searchResults.party.role'), value: 'partyHeader.partySubType', sortable: true });
    headers.push({ text: i18n.t('page.searchResults.case.caseTitle'), value: 'caseHeader.caseTitle', sortable: true });
    headers.push({ text: i18n.t('page.searchResults.case.status'), value: 'caseHeader.caseStatus', sortable: true });
  }
  return headers;
}

export function getSupportedAdvancedSearchTypes ()
{
  let advancedSearchTypes = core.getSupportedAdvancedSearchTypes();

  _.remove(advancedSearchTypes, (st) => {
    return st === CONST.SEARCH_TYPE_CALENDAR;
  });

  return advancedSearchTypes;
}

export function generateSearchDTO (searchType)
{
  let searchDTO = core.generateSearchDTO(searchType);

  if (searchType === CONST.SEARCH_TYPE_PARTY)
  {
    searchDTO[CONST.SEARCH_TYPE_PARTY].partyMiddleName = null;
    searchDTO[CONST.SEARCH_TYPE_PARTY].partyMiddleNameQueryTypeID = null;
    searchDTO[CONST.SEARCH_TYPE_PARTY].alias = null;
    searchDTO[CONST.SEARCH_TYPE_PARTY].aliasQueryTypeID = null;
  }
  else if (searchType === CONST.SEARCH_TYPE_CASE)
  {
    searchDTO[CONST.SEARCH_TYPE_CASE].caseTypeID = null;
    searchDTO[CONST.SEARCH_TYPE_CASE].caseSubTypeID = null;
    searchDTO[CONST.SEARCH_TYPE_CASE].alternateCaseNumber = null;
    searchDTO[CONST.SEARCH_TYPE_CASE].alternateCaseNumberQueryTypeID = null;
    searchDTO[CONST.SEARCH_TYPE_CASE].caseStatusTypeID = null;
  }

  return searchDTO;
}

export function generateAPIQueryObject (searchType, searchDTO)
{
  let query = core.generateAPIQueryObject (searchType, searchDTO);
  if (searchType === CONST.SEARCH_TYPE_CASE)
  {
    if (!_.isNil(searchDTO.case.caseTypeID))
    {
      query['caseHeader.caseTypeID'] = searchDTO.case.caseTypeID;
    }

    if (!_.isNil(searchDTO.case.caseSubTypeID))
    {
      query['caseHeader.caseSubTypeID'] = searchDTO.case.caseSubTypeID;
    }

    if (!_.isNil(searchDTO.case.alternateCaseNumber))
    {
      query['caseHeader.alternateCaseNumbers.alternateCaseNumber'] = searchDTO.case.alternateCaseNumber;
      query['caseHeader.alternateCaseNumbers.alternateCaseNumber.caseNumberSearchType'] = searchDTO.case.alternateCaseNumberQueryTypeID;
    }

    if (!_.isNil(searchDTO.case.caseStatusID))
    {
      query['caseHeader.caseStatusID'] = searchDTO.case.caseStatusID;
    }
  }

  if (searchType === CONST.SEARCH_TYPE_PARTY)
  {
    if (searchDTO.party.actorCategoryID === CONST.ACTOR_CATEGORY_PERSON)
    {
      if (!_.isNil(searchDTO.party.partyMiddleName))
      {
        query['partyHeader.partyActorInstance.middleName'] = searchDTO.party.partyMiddleName;
        query['partyHeader.partyActorInstance.middleNameSearchType'] = searchDTO.party.partyMiddleNameQueryTypeID;
      }
      if (!_.isNil(searchDTO.party.alias))
      {
        query['partyHeader.partyActorInstance.aliasDisplayName'] = searchDTO.party.alias;
        query['partyHeader.partyActorInstance.aliasDisplayNameSearchType'] = searchDTO.party.aliasQueryTypeID;
      }
    }
  }

  return query;
}

export function setSearchDefaults (searchType, searchDTO)
{
  core.setSearchDefaults (searchType, searchDTO);

  if (searchType === CONST.SEARCH_TYPE_CASE)
  {
    searchDTO.case.alternateCaseNumberQueryTypeID = CONST.QUERY_TYPE_CONTAINS; // identifier string searches always use contains
  }
}